export default {
  求和: '求和',
  不展示: '不展示',
  不支持汇总: '不支持汇总',
  数据汇总: '数据汇总'
};
